import { render, staticRenderFns } from "./TableStaffSearchBarDialogComponent.vue?vue&type=template&id=d87b085a"
import script from "./TableStaffSearchBarDialogComponent.vue?vue&type=script&lang=js"
export * from "./TableStaffSearchBarDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports